<template>
    <vue-scroll :ops="ops" ref="vueScroll">
        <div class="product">
            <HeaderMei></HeaderMei>
            <div class="content">
                <div class="proDetail">
                    <div style="text-align: center">
                        <div class="title" style="text-align: left">
                            <span></span>
                            {{allData[code].title}}<em>{{allData[code].subtitle}}</em>
                            <i></i>
                        </div>
                    </div>
                    <div class="productBg clearfix">
                        <div class="block">
                            <el-carousel>
                                <el-carousel-item v-for="(item,index) in allData[code].imgLists" :key="index">
                                    <img :src="item" width="100%" height="100%">
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="bgMs">
                            <div class="bgMstitle">
                                <div class="t">产品背景</div>
                                <i></i>
                                <span>Product background</span>
                            </div>
                            <div class="ms">
                                {{allData[code].bgms}}
                            </div>
                        </div>
                    </div>
                    <div class="feature">
                        <div class="featureTitle">
                            <div class="t">产品特色</div>
                            <i></i>
                            <span>Product features</span>
                        </div>
                        <ul class="clearfix">
                            <li class="clearfix" v-for="(item, index) in allData[code].features" :key="index" :style="allData[code].width">
                                <div class="img" :style="item.icon"></div>
                                <div class="namems">
                                    <div class="name">{{item.name}}</div>
                                    <div class="ms">
                                        {{item.ms}}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="social">
                        <div class="featureTitle">
                            <div class="t">社会效益</div>
                            <i></i>
                            <span>Social results</span>
                        </div>
                        <div class="ms">
                            {{allData[code].social}}
                        </div>
                    </div>
                </div>
            </div>
            <FooterMei></FooterMei>
        </div>
    </vue-scroll>
</template>

<script>
import HeaderMei from '@/components/headerMei';
import FooterMei from '@/components/footerMei';

export default {
    name: 'proDetail',
    components: { HeaderMei, FooterMei },
    data() {
        return {
            ops: {
                rail: {
                    background: '#01a99a',
                    opacity: 0,
                    size: '0px',
                    specifyBorderRadius: false,
                    gutterOfEnds: null,    //轨道距 x 和 y 轴两端的距离
                    gutterOfSide: '0',   //距离容器的距离
                    keepShow: false,   //是否即使 bar 不存在的情况下也保持显示
                    border: 'none'    //边框
                }
            },
            code: 'dl',
            allData: {
                'dl': {
                    title: '短期气候预测平台',
                    subtitle: 'Shotr term climate prediction platform',
                    bgms: '近年来，气候数值模式发展迅速，以DERF2.0、CFSv2、ECMWF、BCC_CSM等为例的多种气候数值模式产品的精细化程度不断提高，模式产品种类不断丰富。 在现阶段的短期气候预测业务中，各类气候数值模式产品已成为气候预测的重要参考依据。随着近年来气候预测业务的改变，气候预测内容不断丰富，预测内容由气候要素拓展至气候事件（干旱、冷空气、低温冰冻、连阴雨、首场大雨、首场暴雨和雨日、雨季监测）， 这对气候数值模式的本地化应用提出了新的要求。加之全国气候预测业务流程有了新的调整，省市级承担辖区内气候预测业务，区县级取消气候预测业务，仅根据需求对省市级气候预测产品进行服务， 这对省市级气候预测业务的自动化，提出了更高的要求。',
                    imgLists: ['./static/images/dl/01.jpg', './static/images/dl/02.jpg', './static/images/dl/03.jpg', './static/images/dl/04.jpg', './static/images/dl/05.jpg', './static/images/dl/06.jpg', './static/images/dl/07.jpg', './static/images/dl/08.jpg', './static/images/dl/09.jpg'],
                    features: [
                        {
                            name: '标准/专业/精美绘图技术',
                            ms: '平台集成NCL、MeteoInfo等专业气象绘图技术，用于色斑图、等值线图、曲线图、柱状图、矢量风场等气候常用图形绘制；',
                            icon: 'background-position: 0 -198px;'
                        },
                        {
                            name: '自由/灵活/多样绘图技术',
                            ms: '平台集成Java Graphics类绘图技术，通过创建画布，Graphics类为画笔的方式，绘制自定义图形（如箱线图）；',
                            icon: 'background-position: -77px -198px;'
                        },
                        {
                            name: '气候事件自动监测技术',
                            ms: '平台设置气候事件监测规则，当实况数据或模式预报数据满足气候事件要求时，前端自动进行气候事件的监测/预测提醒；',
                            icon: 'background-position: -151px -198px;'
                        },
                        {
                            name: '气候算法技术',
                            ms: '平台集成多种应用于气候的诊断分析和评分算法技术，包括线性最小二乘法、相关分析、小波分析、合成分析、EOF分解、奇异值分解、距平相关系数（ACC）、PS评分、CC评分、ZS评分、CS评分等；',
                            icon: 'background-position: -228px -198px;'
                        },
                        {
                            name: '大数据处理技术',
                            ms: '平台采用多种大数据处理技术，保障气候模式预报数据的快速处理：分布式缓存、分布式内存数据库、分布式关系数据库、分布式消息队列；',
                            icon: 'background-position: -303px -198px;'
                        }
                    ],
                    social: '提高气候数值模式本地化应用水平：平台运用多种诊断分析算法、气候指数算法、气候事件/天气过程的统计方法等结合多种气候数值模式的预测产品， 开展了延伸期、月、季气候趋势、延伸期天气过程、本地化气候指数、本地化气候事件的预测。改善气候预测业务自动化水平：平台以气候预测产品的自动化（以及半自动化）制作和气候预测产品的自动评分系统为基础， 提升预报员的业务效率。在保障精细化区县预测业务的同时，为现代化气候预测业务的自动化发展提供新的参照点。',
                    width: 'width:30.3333%'
                },
                'cannas': {
                    title: '强对流天气预警一体化平台',
                    subtitle: 'Integrated platform for strong convective weather warning',
                    bgms: '近年来雷雨大风（如“东方之星”事件），短时强降水（如“北京721”事件）等强对流天气严重威胁人民生命财产安全，社会大众对此类气象灾害的预报需求愈发精细，与此同时，在国家和政府的大力支持下，现代化气象探测手段不断丰富，探测精度逐步提高，越来越多的信息被呈现给预报员。如何处理这些海量、繁杂、专业性强、更新速度快的数据，成为气象从业者所面临的必然挑战。',
                    imgLists: ['./static/images/cannas/1.jpg', './static/images/cannas/2.jpg', './static/images/cannas/3.jpg', './static/images/cannas/4.jpg', './static/images/cannas/5.jpg', './static/images/cannas/6.jpg'],
                    features: [
                        {
                            name: '气象一张图',
                            ms: '研发多类数据叠加显示技术，基于GIS实现多种数据同界面显示，互不影响。为预报员提供更全面、直观的数据支撑服务；',
                            icon: 'background-position: -427px 0;'
                        },
                        {
                            name: '产品制造智能化',
                            ms: '基于产品种类、区域、联防单位等信息，自动生成对应产品，减少预报员的基础工作量，提高工作效率；',
                            icon: 'background-position: 0 0;'
                        },
                        {
                            name: '可修订的预警模型',
                            ms: '基于实况个例和风险点的阈值管理，实现可修订的风险灾害预警模型，提升风险预警准确性；',
                            icon: 'background-position: -257px 0'
                        },
                        {
                            name: '3D-GIS服务',
                            ms: '基于WebGL的3维显示技术，融合WEB-GIS服务，实现中小河流、山洪沟的动态淹没模拟展示；',
                            icon: 'background-position: -509px -101px'
                        },
                        { name: '部门联动', ms: '优化部门间的联动会商机制，保障部门间各项信息互动流通；', icon: 'background-position: -87px 0;' },
                        {
                            name: '数据监控可视化',
                            ms: '自动生成数据日志，对数据异常等情况及时提醒，保障平台数据的稳定性；',
                            icon: 'background-position: -175px 0'
                        },
                        {
                            name: '用户留痕',
                            ms: '记录用户的重要操作信息，绘制成用户的留痕记录。结合统计分析方法，为平台的管理和升级提供数据支撑；',
                            icon: 'background-position: -342px 0'
                        },
                    ],
                    social: '强对流天气预警一体化平台建立起一套全面的监测、预报、信息制作发布以及部门联动系统， 对提高气象灾害预报精准度、及时发布灾害预警信息以及采取防灾救灾联动措施等有积极推动作用。 为保障人民生命财产安全提供智慧解决方案。',
                    width: 'width:22%'
                },
                'rg': {
                    title: '人工影响天气一体化平台',
                    subtitle: 'Artificial weather integration platform',
                    bgms: '随着社会经济的飞速发展，人工影响天气在增雨防雹和重大活动保障中的社会需求日益彰显，成为各级党委、政府应对气象自然灾害、保障人民生命财产安全和应对水资源压力、 保障社会经济可持续发展的重要手段，越来越受到各级领导的重视和广大群众的关注。但由于人工影响天气作业复杂、参与作业人员多、专业要求高、作业精度和时间要求高、 数据量大、环境复杂等多方面的综合原因导致人影发展具有一定瓶颈。',
                    imgLists: ['./static/images/rg/01.jpg', './static/images/rg/02.jpg', './static/images/rg/03.jpg', './static/images/rg/04.jpg', './static/images/rg/05.jpg', './static/images/rg/06.jpg', './static/images/rg/07.jpg', './static/images/rg/08.jpg'],
                    features: [
                        {
                            name: '一体化',
                            ms: '平台以五段式人影业务为基础，梳理、完善各阶段人影作业业务流程，是集作业前（作业分析）、作业中（实时指挥）、作业后（效果评估）、 综合管理以及手机终端平台等各项业务为一体的综合性业务平台，使用方便，便于统一管理；',
                            icon: 'background-position: -379px -198px;'
                        },
                        {
                            name: '集成化',
                            ms: '多源人影资料集成，为用户提供全面、完善的数据、资料支撑服务；PC端与手机端的集成，为用户提供便捷的移动业务平台， 实现了“指尖上”的业务管理，极大提高了上下级信息交互和作业指挥效率；视屏设备与平台的集成， 提高指挥中心对作业单位的指导力度和安全监管力度；',
                            icon: 'background-position: -455px -198px;'
                        },
                        {
                            name: '气候专业化',
                            ms: '风暴体识别预报技术，为防雹作业提供更精确的风暴体属性（位置、体积、含水量等）；条件识别技术，基于作业条件， 自动识别作业区，提升作业决策效率；效果评估检验技术，丰富多样的效果评估检验技术，为用户提供更全面的效果评估参考依据；',
                            icon: 'background-position: -531px -198px;'
                        },
                        {
                            name: '自动化',
                            ms: '决策服务产品制作自动化，有效减少用户基础工作，提升工作效率；作业参数计算自动化，缩减用户对作业参数的判定时间， 规避作业指挥的随意性，使作业指挥更客观、更科学；',
                            icon: 'background-position: 0 -294px;'
                        }
                    ],
                    social: '人工影响天气一体化平台充分运用新技术新手段，以智能手机、终端对讲、视频摄像为扩展设备， 创新作业通讯及指挥方式，实现人工影响天气作业全程监控指挥，提高了指挥中心对作业单位的指导力度和安全监管力度， 规范了弹药、装备、作业人员等的管理制度，为各省三级管理、三级指挥和四级作业建立了自动化的管理业务体系。',
                    width: 'width:47%'
                },
                'nl': {
                    title: '城市内涝气象风险预警平台',
                    subtitle: 'Meteorological risk early warning platform for urban waterlogging',
                    bgms: '近年来，我国城镇化快速推进，城市面积不断扩大、城镇人口急剧增加、城市地面硬化率显著提高。城镇化的快速推进，给社会经济发展注入了活力，却也加重了城区内涝的风险。城市热岛效应的出现，更易引发局地的强对流天气，造成城市地区频繁出现暴雨或极端降水。城区排水系统在频率愈加频繁、降水量越来越大的暴雨过程面前，显得难以应对。受目前监测手段不足和预报技术条件限制，全国大多数城市的城区暴雨预报预警精细化程度尚不足以满足社会对城区内涝等级预报预警的要求。',
                    imgLists: ['./static/images/nl/01.jpg', './static/images/nl/02.jpg', './static/images/nl/03.jpg', './static/images/nl/04.jpg'],
                    features: [
                        {
                            name: '城市内涝预警模型',
                            ms: '建立城市内涝渍水点/渍水区与致灾雨量之间的雨涝模型，当实况雨量或预报雨量达到致灾雨量条件时，平台自动生成报警/预警产品，并发起提醒；',
                            icon: 'background-position: -427px -101px;'
                        },
                        {
                            name: '主客观降水融合技术',
                            ms: '有效融合客观降水预报和预报员人工修订，配合实况检验技术，提升预报准确性；',
                            icon: 'background-position: -344px -101px;'
                        },
                        {
                            name: '降水预报修订反馈',
                            ms: '有效融合人工修订的降水预报产品和城市内涝风险预警模型，应用修订后的降水预报产品，实时修正城市内涝预报预警产品；',
                            icon: 'background-position: -248px -101px;'
                        }
                    ],
                    social: '城市内涝气象风险预警平台的建立，通过应用降雨量与城区内涝等级之间的雨涝关系，协助预报员实现了从降雨预报到城市内涝气象风险等级预报预警的转变。 有效改善了现阶段气象台的气象产品应用能力与对外服务能力，丰富了气象服务产品。平台业务化的成功运用，及时地为各级领导和防汛、城管等部门提供城市内涝气象风险预报预警产品，为防汛调度决策和指挥抢险救灾提供了有力的技术支持和科学决策依据， 有效地减少了积水给城市带来的经济损失。',
                    width: 'width:30.3333%'
                },
                'jc': {
                    title: '基层气象风险预警预报平台',
                    subtitle: 'Meteorological risk early-warning and forecasting platform at the base level',
                    bgms: '近年来，中小河流洪水、山洪地灾等事件频发，给人民生命财产安全带来重大隐患，已引起国内政府机关及社会各界的广泛关注。短时临近预报特别是强对流性天气所引起的洪水、山洪、山体滑坡、泥石流等次生灾害的预报，作为世界性难题，存在技术手段有限，整体水平不高、预测质量尚不稳定等诸多问题。 气象服务能力和社会公众的需求之间还存在较大差距，给针对基层风险的预报预警服务工作提出了更高要求。基层风险预警涉及数据种类众多，收集困难，加之此类信息在各政府事业单位中共享困难，使得气象部门难以及时获得灾情信息，给气象部门防灾减灾的职责提出了更多难题。',
                    imgLists: ['./static/images/jc/01.jpg', './static/images/jc/02.jpg', './static/images/jc/03.jpg', './static/images/jc/04.jpg'],
                    features: [
                        {
                            name: '气象一张图',
                            ms: '研发多类数据叠加显示技术，基于GIS实现多种数据同界面显示，互不影响。为预报员提供更全面、直观的数据支撑服务；',
                            icon: 'background-position: -427px 0;'
                        },
                        {
                            name: '可修订的预警模型',
                            ms: '基于实况个例和风险点的阈值管理，实现可修订的风险灾害预警模型，提升风险预警准确性；',
                            icon: 'background-position: -257px 0'
                        },
                        {
                            name: '人工订正反馈机制',
                            ms: '有效融合人工修订的降水预报产品和基层气象风险预警模型，应用修订后的降水预报产品数据，实时修正基层气象风险预警产品；',
                            icon: 'background-position: -158px -101px;'
                        },
                        {
                            name: '3D-GIS服务',
                            ms: '基于WebGL的3维显示技术，融合WEB-GIS服务，实现中小河流、山洪沟的动态淹没模拟展示；',
                            icon: 'background-position: -509px -101px'
                        },
                    ],
                    social: '提升气象服务的针对性与专业性：平台整合气象、水利、国土等多部门基础数据，结合气象部门现有的降水预报手段。通过基层气象风险预警预报平台，成功由传统的降水量预报预警转变为对风险点的气象风险等级预报预警。提升基层风险预报预警业务的适应性和保障水平：基层气象风险预警预报平台孕育于现阶段气象部门对气象灾害的认识和服务的转变，平台协助气象部门实现从传统的灾中抗灾、灾后救灾转变为现如今的风险预估、防患于未然。为中小河流治理、山洪地质灾害防御、生态环境综合治理提供更专业、更可靠的气象保障。',
                    width: 'width:22%'
                },
            }
        }
    },
    props: ['params'],
    activated() {
        let params = this.$route.params;
        if (params && params.code) {
            this.code = params.code;
            console.log(params.code);
        } else {
            this.code = 'dl';
        }
    },
    methods: {}
}
</script>

<style scoped lang="less">
    .product {
        width: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            flex: 1;
            padding: 0 20px;
            color: #ffffff;
            .text-item {
                margin: 20px 0;
                .title {
                    height: 30px;
                    line-height: 30px;
                    font-size: 24px;
                }
                .english {
                    font-size: 14px;
                }
                .intro {
                    height: 40px;
                    line-height: 40px;
                }
            }
            .img-items {
                display: flex;
                .img-item {
                    flex: 1;
                    position: relative;
                    cursor: pointer;
                    .img {
                        border: solid 1px #ffffff87;
                        padding: 10px 0;
                        text-align: center;
                        min-height: 200px;
                        img {
                            transition: all 0.5s;
                        }
                    }
                    .name {
                        text-align: center;
                        border: 1px solid #ffffff87;
                        width: 70%;
                        border-radius: 30px;
                        margin: auto;
                        margin-top: 20px;
                        padding: 5px 0;
                    }
                    &:hover {
                        .img {
                            img {
                                transform: scale(1.05);
                            }
                        }
                    }
                }
            }
        }
    }

    .proDetail {
        .black {
            cursor: pointer;
        }
        .title {
            display: inline-block;
            position: relative;
            font-size: 30px;
            height: 70px;
            margin: auto;
            margin-top: 60px;
            em {
                font-style: normal;
                display: block;
                font-size: 15px;
            }
            i {
                display: inline-block;
                width: 60px;
                height: 1px;
                background-color: #ffffff87;
                position: absolute;
                bottom: 2px;
                right: 0px;
            }
            span {
                display: inline-block;
                width: 120px;
                height: 1px;
                background-color: #ffffff87;
                position: absolute;
                top: -2px;
                left: 0px;
            }
        }
        .productBg {
            margin-top: 70px;
            /deep/ .block {
                float: left;
                width: 55%;
                .el-carousel__container {
                    height: 420px;
                }
                .el-carousel__button {
                    background-color: #7F7F7F;
                    opacity: 1;
                    height: 10px;
                    border-radius: 30px;
                    width: 10px;
                }
                .el-carousel__indicator.is-active button {
                    background-color: #0079C3;
                    width: 30px;
                }
            }
            .bgMs {
                width: 42%;
                float: right;
                .bgMstitle {
                    position: relative;
                    .t {
                        font-size: 26px;
                    }
                    i {
                        display: inline-block;
                        width: 140px;
                        position: absolute;
                        top: 35px;
                        left: 0px;
                        height: 1px;
                        background-color: #ffffff87;
                    }
                    span {

                    }
                }
                .ms {
                    margin-top: 20px;
                    font-size: 15px;
                    line-height: 30px;
                    letter-spacing: 1px;
                }
            }
        }
        .feature {
            margin-top: 110px;
            ul {
                margin: 0;
                padding: 0;
                margin-left: -3%;
                li {
                    width: 30.333%;
                    float: left;
                    margin-left: 3%;
                    list-style: none;
                    min-height: 130px;
                    margin-top: 40px;
                    .img {
                        float: left;
                        width: 64px;
                        height: 81px;
                        vertical-align: middle;
                        overflow: hidden;
                        background: url(../../static/images/sc-icon.png) no-repeat;
                    }
                    .namems {
                        float: right;
                        width: calc(100% - 84px);
                        .name {
                            font-size: 18px;
                        }
                        .ms {
                            font-size: 14px;
                            line-height: 25px;
                        }
                    }
                }
            }
        }
        .social {
            margin-top: 50px;
            margin-bottom: 50px;
            .ms {
                margin-top: 20px;
                line-height: 30px;
                letter-spacing: 1px;
            }
        }
        .featureTitle {
            position: relative;
            text-align: center;
            .t {
                font-size: 30px;
            }
            i {
                display: inline-block;
                width: 100px;
                position: absolute;
                top: 40px;
                left: 50%;
                height: 1px;
                margin-left: -50px;
                background-color: #ffffff87;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/proDetail.vue